export const LOAD_ROLES = 'load_roles';
export const ROLES_LOADED = 'roles_loaded';
export const SYNCING = 'syncing';
export const SYNC_FAILED = 'sync_has_failed';
export const LOAD_TENDER_TYPES = 'load_tender_types';
export const TENDER_TYPES_LOADED = 'tender_types_loaded';
export const LOAD_TENDER_VALIDATORS = 'load_tender_validators';
export const TENDER_VALIDATORS_LOADED = 'tender_validators_loaded';
export const TENDER_VALIDATORS_LOAD_ERROR = 'tender_validators_load_error';
export const TOUCH_POINT_GROUPS_LOADED = 'touch_point_groups_loaded';
export const TOUCH_POINT_GROUPS_ERROR = 'touch_point_groups_error';
export const LOAD_TOUCH_POINT_GROUPS = 'load_touch_point_groups';
